import React, { Component } from 'react';
import { firebaseAuth,ref } from '../config/constants'
import Categories from './Categories'

import Sidebar from './inc/Sidebar';
import Header from './inc/Header';
import Title from './inc/Title';
import Footer from './inc/Footer';


class Category extends Component {

    constructor(){
        super();
        this.addCategory = this.addCategory.bind(this);
        this.removeCategory = this.removeCategory.bind(this);
        this.state = {
            userId:"",
            user :{},
            errorMsg : "",
            categoryList :{}
        };
    }
    
    componentWillMount() {

        this.listener = firebaseAuth().onAuthStateChanged(user=>{
            if (user){
                var db = ref.child("users").child(user.uid);
                    db.on("value",function(data){
                      
                      this.setState({
                        userId:data.key,
                        user:data.val()
                      });

                    }.bind(this));
            }else{
              this.props.history.push("/login");
            }
        }); 

        var category = ref.child("Categories")
            category.on("value", function(snap){
                this.setState({
                    categoryList : snap.val()
                })
            }.bind(this))     
    }

    componentWillUnmount(){
      this.listener()
    }

    addCategory(e){
        e.preventDefault();
        if(this.name.value){
            let categoryDetails = {
                category : this.name.value
            }
            ref.child("Categories").push(categoryDetails)
                .then(alert("New Category has been added"))
                .catch(function(error){
                    this.setState({
                        errorMsg : "Opps"+error.code
                    })
                })
        }else{
            this.setState({
                errorMsg:"Please Fill up the both fields"
            })
        }
        this.categoryForm.reset();
    }

    removeCategory(catId){
        let categoryList = this.state.categoryList;
        let category = {}
        if(window.confirm("Do you really want to remove this Unit")===true){
            Object.keys(categoryList).map(key =>{
                category = categoryList[catId] 
                if(category === categoryList[key]){
                    let statusUpdate ={
                        category : null
                    }
                    ref.child("Categories").child(catId).update(statusUpdate).then(()=>{
                        alert("Category successfully deleted ")
                    })// end of update in the firebase
                } // end of condition  
            } ) //end of loop
        }// end of window confirm
    }

    render() {
      
        return (
            <div id="page-wrapper">
                <div id="page-container" className="sidebar-partial sidebar-visible-lg sidebar-no-animations">
                    <Sidebar  role={this.state.user.role} />
                    <div id="main-container">
                        <Header />
                        <div id="page-content">
                            <Title title="Category" />
                            <div className="block">
                                <form className="form-horizontal form-bordered" ref={(input) => {this.categoryForm=input}}  onSubmit={(e)=>this.addCategory(e)}>
                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="category-name">Category Name</label>
                                        <div className="col-md-4">
                                            <input className="form-control"  ref={(input) => {this.name=input}} type="text" /> 
                                        </div>
                                        <div className="col-md-4">
                                            <button type="submit" className="btn btn-sm btn-primary"><i className="fa fa-floppy-o"></i> Add Category</button>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        {
                                            this.state.errorMsg &&
                                        <label className="col-md-3 control-label" htmlFor="error-msg">{this.state.errorMsg}</label>
                                        }
                                    </div>  
                                    {/*<!--  -->*/}
                                    {/*<!-- <div className="form-group form-actions">  -->*/}
                                    {/*<!-- <div className="col-md-9 col-md-offset-3"> -->*/}
                                    {/*<!-- <button type="submit" className="btn btn-sm btn-primary"><i className="fa fa-floppy-o"></i> Add Category</button> -->*/}
                                    {/*<!--   </div>-->*/}
                                    {/*<!-- </div> -->*/}
                                </form>
                            </div>
                            <div className="compoWrapper">
                                <div className="table-responsive">
                                    <table className="table table-bordered table-vcenter">
                                        <thead>
                                            <tr>
                                                <th>Category</th>
                                                <th className="text-center">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            { 
                                                this.state.categoryList &&
                                                Object.keys(this.state.categoryList).map(key => <Categories key={key} index={key} details ={this.state.categoryList[key]}
                                                removeCategory={this.removeCategory}/>) 
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
      
        );
    }
}

export default Category;



// WEBPACK FOOTER //
// ./src/components/Category.js